import React from 'react';
import {PencilAltIcon} from "@heroicons/react/outline";

function EditButton (props)  {
    return (
        <PencilAltIcon onClick={props.onClick} className="bg-gray-200 opacity-70 hover:opacity-100 transition-all cursor-pointer h-6 text-blue-700 rounded-md p-1"/>
    );
}

export default EditButton;